// extracted by mini-css-extract-plugin
export default {"notice":"styles_notice__pTNx9","noticeContent":"styles_noticeContent__Lrdn7","error":"styles_error__PeEIK","success":"styles_success__O8aHQ","warning":"styles_warning__sFSxT"};